import { useContext } from 'react';
import moment from 'moment';

import ClientContext from '@/contexts/client.context';
import Container from './Container';
import Inner from './Inner';
import Subtitle from './Subtitle';
import Title from './Title';
import { Wrapper, OuterWrapper } from './Wrapper';
import EligibilityClaim from './EligibilityClaim';
import Disclaimer from './Disclaimer';
import CountriesForm from './CountriesForm';
import LinkAccount from './LinkAccount';

import EnrollButton from '@/app/_components/core/EnrollButton';
import { products } from '@/utils/products';
import { Logos } from '@/app/components/shared/Logos/Logos';
import Section from '@/components/ui/Section';

const Header = ({ className, content, extraLabel, showSwordLogo, countries, userName }) => {
  const {
    title,
    subtitle,
    buttonLabel,
    eligibilityClaim,
    disclaimer,
    logos,
    backgroundImage,
    showSignIn,
  } = content;
  const { client, selectClientCountry } = useContext(ClientContext);
  const hasLaunched = !client.launchDate
    ? true
    : moment(client.launchDate).isSameOrBefore(moment());
  const urlOnboarding = process.env.NEXT_PUBLIC_ONBOARDING_BASE_URL
    ? process.env.NEXT_PUBLIC_ONBOARDING_BASE_URL
    : 'https://onboarding.swordhealth.com/';

  const titleWithoutUsername = title
    .trim()
    .substring('{{USER_NAME}}'.length)
    .replace(/,/g, ' ')
    .trim();
  const formattedTitle =
    titleWithoutUsername.charAt(0).toUpperCase() + titleWithoutUsername.slice(1);

  return (
    <Section>
      <OuterWrapper>
        <Wrapper
          className={className}
          imageUrl={
            backgroundImage?.url ??
            backgroundImage?.data?.attributes?.url ??
            '/assets/backgrounds/client_header__desktop.jpg'
          }
        >
          <Inner>
            <Container>
              <Logos logos={logos} showSwordLogo={showSwordLogo} />
              <Title id={'header-title'} extraLabel={extraLabel}>
                {userName?.length
                  ? title?.replace('{{USER_NAME}}', userName)
                  : !userName && title.includes('{{USER_NAME}}')
                  ? formattedTitle
                  : title}
              </Title>
              {subtitle && <Subtitle id={'header-subtitle'}>{subtitle}</Subtitle>}

              {client.isActive && hasLaunched && !!countries.length && (
                <CountriesForm
                  id={'header-countries-form'}
                  countries={countries}
                  buttonLabel={buttonLabel}
                  product={products.THRIVE}
                />
              )}

              {client.isActive && hasLaunched && !countries?.length && (
                <EnrollButton
                  id={'header-enroll-button'}
                  isActive={client.isActive}
                  buttonLocation="header"
                  client={client}
                  buttonLabel={buttonLabel}
                  product={products.THRIVE}
                  triage={client?.hasTriage}
                  redirectToApp={client?.redirectToApp}
                />
              )}

              {client.isActive &&
                hasLaunched &&
                showSignIn &&
                (client.countries.length ? (
                  selectClientCountry.country && (
                    <LinkAccount
                      id={'header-link-account'}
                      client={client}
                      selectClientCountry={selectClientCountry}
                      url={urlOnboarding}
                    />
                  )
                ) : (
                  <LinkAccount
                    id={'header-link-account'}
                    client={client}
                    selectClientCountry={selectClientCountry}
                    url={urlOnboarding}
                  />
                ))}

              {client.isActive && !hasLaunched && (
                <EnrollButton
                  id={'header-enroll-button'}
                  isActive={client.isActive}
                  client={client}
                  buttonLabel={buttonLabel}
                  triage={client?.hasTriage}
                  redirectToApp={client?.redirectToApp}
                />
              )}

              {eligibilityClaim && <EligibilityClaim>{eligibilityClaim}</EligibilityClaim>}
              {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
            </Container>
          </Inner>
        </Wrapper>
      </OuterWrapper>
    </Section>
  );
};

export default Header;
